module.exports = __webpack_public_path__ + "img/门禁控制器 (1).fa1987a4.jpg";